import { createQuery } from '@tanstack/svelte-query';
import { fetchProfile } from '$lib/api/user';
import type { UserProfile } from '$lib/types/user';

export const profileQueryKey = ['profile'] as const;

export function profileQueryOptions() {
	return {
		queryKey: profileQueryKey,
		queryFn: () => fetchProfile(),
		staleTime: 5 * 60 * 1000
	};
}

export const profileQuery = () => createQuery<UserProfile>(() => profileQueryOptions());
